import { Component, createContext } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { Config, ConfigProps, MarketInfoProps } from 'etc/types';
import { SP_ACCOUNTS_URL, SPOTIFYCOM_URL, SUPPORT_SITE_URL, SP_EMBED_URL } from 'lib/shared/config/config';

import { withMarketInfo } from '../MarketInfo/MarketInfoProvider';

export const ConfigContext = createContext<Config>({} as Config);

export const withConfig =
  <P extends ConfigProps>(Comp: React.ComponentType<P>) =>
  (props: Omit<P, keyof ConfigProps>) =>
    <ConfigContext.Consumer>{config => <Comp {...(props as P)} config={config} />}</ConfigContext.Consumer>;

const getConfig = ({ market, locale }: { market: string; locale: string }) => {
  const conf = {
    supportSiteUrl: (path = '/') => `${SUPPORT_SITE_URL}/${market + path}`,
    spotifyComUrl: (path = '/') => `${SPOTIFYCOM_URL}/${market + path}`,
    spAccountsUrl: (path = '/') => `${SP_ACCOUNTS_URL}/${locale.split('-')[0] + path}`,
    spEmbedUrl: (path = '') => `${SP_EMBED_URL}/${path}`,
  } as Config;

  conf.contactFormAnonymous = () => conf.supportSiteUrl('/contact-spotify-anonymous/');

  return conf;
};

interface ConfigProviderProps extends MarketInfoProps, RouteComponentProps {
  children: React.ReactNode;
}

class ConfigProvider extends Component<ConfigProviderProps> {
  render() {
    const { marketInfo, children } = this.props;

    const contextValue = {
      ...getConfig(marketInfo),
    };

    return <ConfigContext.Provider value={contextValue}>{children}</ConfigContext.Provider>;
  }
}

export default withMarketInfo(withRouter(ConfigProvider));
